export const EXTERNAL_BOOKING_SOURCE = {
    CLASSPASS: 'classpass',
    ONEFIT: '1fit',
}

export function isOccupiedClasspassSpot(spot) {
    return (
        spot.cp_username ||
        spot.reservationSource === EXTERNAL_BOOKING_SOURCE.CLASSPASS
    )
}

export function isOccupied1FitSpot(spot) {
    return spot.reservationSource === EXTERNAL_BOOKING_SOURCE.ONEFIT
}

export function isOccupiedExternalSpot(spot) {
    return spot.hasOwnProperty('cp_username') || Boolean(spot.reservationSource)
}

export function isOccupiedVibefamSpot(spot) {
    return !spot.cp_username && !spot.reservationSource
}

export function isActivatedForExternalBooking(obj, externalBookingSource) {
    if (externalBookingSource === EXTERNAL_BOOKING_SOURCE.CLASSPASS) {
        return obj.isClasspassActive
    } else if (externalBookingSource === EXTERNAL_BOOKING_SOURCE.ONEFIT) {
        return obj.is1FitActive
    } else if (!externalBookingSource) {
        return obj.isClasspassActive || obj.is1FitActive
    }
    return false
}
